import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ModalDialog } from "@financeable-com-au/financeable-ui";
import { lodgeAIAutomationSelector, resetLodgeAI } from "@/store/slices/lodgeAISlice";
import { useLodgeAIAction } from "@/hooks/useLodgeAI";
import { AutomationFrame } from "../AutomationFrame";
import { ErrorFrame } from "../ErrorFrame";

const modalWidth = "90vw";

interface AutomationModalProps {
  modalOverflowRef: React.RefObject<HTMLDivElement>;
}

const AutomationModal = ({ modalOverflowRef }: AutomationModalProps) => {
  const dispatch = useDispatch();
  const lodgeAIAutomation = useSelector(lodgeAIAutomationSelector);
  const { startAutomation } = useLodgeAIAction();

  // If the session is closed (e.g. due to timeout), reset LodgeAI.
  useEffect(() => {
    if (lodgeAIAutomation?.isClosed) {
      dispatch(resetLodgeAI());
    }
  }, [lodgeAIAutomation?.isClosed, dispatch]);

  // Start automation.
  useEffect(() => {
    // If automation is connected, then start automation.
    if (lodgeAIAutomation?.connectionState.isConnected) {
      startAutomation();
    }
  }, [lodgeAIAutomation?.connectionState.isConnected, startAutomation]);

  // Scroll to top of modal when there is a manual intervention with a warning or error intent.
  useEffect(() => {
    if (modalOverflowRef.current && !!lodgeAIAutomation?.manualInterventionIntent) {
      modalOverflowRef.current.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [lodgeAIAutomation?.manualInterventionIntent]);

  return (
    <ModalDialog minWidth={modalWidth} maxWidth={modalWidth} zIndex={1} padding={0}>
      {lodgeAIAutomation?.isErrored ? <ErrorFrame /> : <AutomationFrame />}
    </ModalDialog>
  );
};

export { AutomationModal };
